import React from "react";
import { useState } from "react";
import '../pages/Contact.css'

const Contact = () => {

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");

    const formBody = new URLSearchParams(formData).toString();

    try {
      const response = await fetch("https://peracause.com/backend-files/per-a-cause/contact-per-a-cause.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formBody,
      });

      const result = await response.json();

      if (result.status === "success") {
        setResponseMessage("Message sent successfully! ✅");
        setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "" });
      } else {
        setResponseMessage("Error: " + result.message);
      }
    } catch (error) {
      setResponseMessage("Error sending message. Please try again.");
    } finally {
      setLoading(false);
    }
  };



  return (

    <div className="">
      {/* Hero Section Starts */}
      <div className="about-hero d-flex align-items-center">
        <div className="about-hero-inner container">
          <div className="hero-content">
            <h2 className="hero-title title display-3">Contact Us</h2>
            <p>Home / Contact Us</p>
          </div>
        </div>
      </div>
      {/* Hero Section Ends */}
      {/* Show loading animation */}
      {/* Show loading animation */}
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>Sending message...</p>
        </div>
      )}
      {/* <!-- contact us start  --> */}
      <section class="container-fluid py-5 ">
        <div class="container">
          <div class="row align-items-center justify-content-center">
            <div class="col-lg-6 pe-lg-5 my-3">
              <h2 class="display-4 title">
                Let’s Start Your Digital Success Story
              </h2>
              <p class="fs-5">
                Ready to take your business to the next level? Whether you’re looking to boost your online
                presence, drive more traffic, or convert leads into loyal customers, our team is here to help.
                Reach out to us today—we’d love to hear from you! Have a question or want to discuss your project? Fill out the form below, and we’ll get back to you within 24 hours.


              </p>
              <div class="row contact-points rounded-4 p-3">
                <div class="col-md-6">
                  <a href="tel:+919949047099" class="d-flex align-items-center justify-content-center flex-column get-in-touch-point text-decoration-none mb-3">
                    <i
                      class="fa-solid fa-phone point d-flex align-items-center justify-content-center rounded-circle mb-3"></i>
                    <h3 class="title">
                      Phone Number
                    </h3>
                    <h5 class="m-0 title fs-4">+91 99490 47099</h5>
                  </a>
                </div>
                <div class="col-md-6">
                  <a href="mailto:info@peracause.com" class="d-flex align-items-center justify-content-center flex-column get-in-touch-point text-decoration-none mb-3">
                    <i
                      class="fa-solid fa-envelope point d-flex align-items-center justify-content-center rounded-circle mb-3"></i>
                    <h3 class="title">
                      Email Address
                    </h3>
                    <h5 class="m-0 title fs-4">info@peracause.com</h5>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-6 my-3">
              <div class="contact-form-container p-4 rounded-5">

                <form id="contactForm" action="contact.php" method="POST" className="p-3" onSubmit={handleSubmit}>
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <input type="text" placeholder="First Name" class="form-control py-3 px-3 glass-background" id="firstName" name="firstName" onChange={handleChange} required />
                    </div>
                    <div class="col-md-6 mb-3">
                      <input type="text" placeholder="Last Name" class="form-control py-3 px-3 glass-background" id="lastName" name="lastName" onChange={handleChange} required />
                    </div>

                  </div>

                  <div class="row">
                    <div class=" mb-3">
                      <input type="tel" placeholder="Mobile Number" class="form-control py-3 px-3 glass-background" id="phone" name="phone" onChange={handleChange} required />
                    </div>
                    <div class=" mb-3">
                      <input type="email" placeholder="Email Address" class="form-control py-3 px-3 glass-background" id="email" name="email" onChange={handleChange} required />
                    </div>
                    {/* <div class=" mb-3">
                      <input type="text" placeholder="Subject" class="form-control py-3 px-3 glass-background" id="subject" name="subject" required />
                    </div> */}
                  </div>

                  <div class="mb-3">
                    <textarea class="form-control glass-background text-white" placeholder="Message" id="message" name="message" rows="4" onChange={handleChange} required></textarea>
                  </div>

                  {/* <button type="submit" class="btn btn-primary">Submit</button> */}

                  <div className="row justify-content-center">
                    <div className="col-10">
                      {/* From Uiverse.io by Li-Deheng */}
                      <div className="btn-container my-3">
                        <button className="btn-content justify-content-center py-2 col-12 border-0" type="submit">
                          <span className="btn-title text-center">{loading ? "Sending..." : "SEND A MESSAGE"}</span>
                          <span className="icon-arrow">
                            <svg
                              width="30px"
                              height="30px"
                              viewBox="0 0 66 43"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <path
                                  id="arrow-icon-one"
                                  d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                                  fill="#FFFFFF"
                                ></path>
                                <path
                                  id="arrow-icon-two"
                                  d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                                  fill="#FFFFFF"
                                ></path>
                                <path
                                  id="arrow-icon-three"
                                  d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                                  fill="#FFFFFF"
                                ></path>
                              </g>
                            </svg>
                          </span>
                        </button>
                      </div>

                    </div>
                  </div>

                  {responseMessage && <p>{responseMessage}</p>}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- contact us end  --> */}
      {/* Map Starts */}
      <div class="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.148198345872!2d78.38179841637613!3d17.404674146864917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93ef1c4a5751%3A0xbd9a259d073f20be!2sRandom%20Grand%20Guest%20house%20and%20co%20living%20PG!5e0!3m2!1sen!2sin!4v1740573923608!5m2!1sen!2sin"
          width="100%"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade">
        </iframe>
        <div class="map-overlay"></div>
      </div>
      {/* Map Ends */}
    </div>
  );
};

export default Contact;
